import { render, staticRenderFns } from "./CustomerDynamics.vue?vue&type=template&id=8e072aae&scoped=true&"
import script from "./CustomerDynamics.vue?vue&type=script&lang=js&"
export * from "./CustomerDynamics.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDynamics.vue?vue&type=style&index=0&id=8e072aae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e072aae",
  null
  
)

export default component.exports